export default "__VITE_ASSET__6DocDys$__"